export default __webpack_public_path__ + "static/media/Apple_Wallet.f977e5b2.png";